export const VERIFY_EMAIL_TIME_OFFSET = 5;
